module.exports = __webpack_public_path__ + "static/media/m1.5720dd43.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-cluster-icons/m1.png
// module id = 506
// module chunks = 0